<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-items-end tw-mb-4">
      <button
        @click="navigateToCreatePayment"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('payment.titles.new_payment') }}
      </button>
    </div>
    <PaymentsFancyTable :customerId="selectedCustomerId" :isDashboard="false" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import PaymentsFancyTable from '@/views/Payments/Table/PaymentsFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';

import { useI18n } from 'vue-i18n';
import router from '@/router';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';
import { useCustomerStore } from '@/stores/customer.store';

const navigateToCreatePayment = () => {
  router.push({ name: 'create-payment' });
};

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.payments',
    },
  ]);
});
</script>
